import {NORMAL_VARIANT_STYLES, VARIANT_STYLE_MAPPING } from "../constants";

const STYLE_KEYS = {
	TEXT_ALIGNMENT: "textAlignment",
	TEXT_ALIGNMENT_MOBILE: "mobileTextAlignment",
	TITLE_SPACING : 'sectionTitleSpacing'

};
const STYLE_VALUES = {
	TEXT_CENTERED: "Center",
	TEXT_LEFT: "Left",
	TEXT_RIGHT: "Right",
	SPACING_NORMAL: "64px",
	SPACING_SMALL : '32px',
	SPACING_X_SMALL : '0px',
	// Add more mappings as needed
};

const DESCRIPTION_STYLE_KEYS = [STYLE_KEYS.TEXT_ALIGNMENT, STYLE_KEYS.TEXT_ALIGNMENT_MOBILE];
	const HEADER_STYLE_KEYS = [STYLE_KEYS.TEXT_ALIGNMENT, STYLE_KEYS.TEXT_ALIGNMENT_MOBILE, STYLE_KEYS.TITLE_SPACING];
	const IMAGE_STYLE_KEYS = [];
	const SECTION_STYLE_KEYS = [];

const OMITTED_KEYS = ["title"];



// const formatStylingObject = (styling: SectionStylingObject): FormattedStylingObject => {
const formatStylingObject = (styling) => {
	return {
		descriptionStyling: styling.descriptionStyling.join(" "),
		headerStyling: styling.headerStyling.join(" "),
		imageStyling: styling.imageStyling.join(" "),
		sectionStyling: styling.sectionStyling.join(" "),
		textColor: styling.textColor || "text-is2-gray-900",
		wrapperColor: styling.wrapperColor || "bg-white",
		inverseColor: styling.inverseColor || "bg-white",
	};
};

// export const getSectionStyling = (
// 	pageSectionStyling: Record<string, Record<string, string>>,
// 	variant: string,
// ): FormattedStylingObject => {

	/*
	DEPRECEATED - Use contentBlockStyling instead
	*/
export const getSectionStyling = (
	pageSectionStyling,
	variant,
) => {
	const { fields: sectionStyling } = pageSectionStyling ?? { fields: {} };

	const { WRAPPER_COLOR, TEXT_COLOR, INVERSE_COLOR } =
		VARIANT_STYLE_MAPPING[variant] || NORMAL_VARIANT_STYLES;

	if (!sectionStyling || Object.keys(sectionStyling).length === 0) {
		// const styling: SectionStylingObject = {
		const styling = {
			descriptionStyling: ["text-center"],
			headerStyling: ["text-center pb-8 md:pb-[64px]"],
			imageStyling: [],
			sectionStyling: [],
		};
		styling.sectionStyling.push(WRAPPER_COLOR);
		styling.headerStyling.push(TEXT_COLOR);
		styling.textColor = TEXT_COLOR;
		styling.wrapperColor = WRAPPER_COLOR;
		styling.inverseColor = INVERSE_COLOR;
		return formatStylingObject(styling);
	}

	
	// const formattedSectionStyling: SectionStylingObject = Object.entries(sectionStyling).reduce(
	const formattedSectionStyling = Object.entries(sectionStyling).reduce(
		(acc, [key, value]) => {
			if (OMITTED_KEYS.includes(key)) {
				return acc;
			}
			const className = getClassName(key, value);
			if (DESCRIPTION_STYLE_KEYS.includes(key)) {
				acc.descriptionStyling.push(className);
			}
			if (HEADER_STYLE_KEYS.includes(key)) {
				acc.headerStyling.push(className);
			} else if (IMAGE_STYLE_KEYS.includes(key)) {
				acc.imageStyling.push(className);
			} else if (SECTION_STYLE_KEYS.includes(key)) {
				acc.sectionStyling.push(className);
			}
			return acc;
		},
		{
			descriptionStyling: [],
			headerStyling: [],
			imageStyling: [],
			sectionStyling: [],
		}
	);

	formattedSectionStyling.sectionStyling.push(WRAPPER_COLOR);
	formattedSectionStyling.headerStyling.push(TEXT_COLOR);
	formattedSectionStyling.textColor = TEXT_COLOR;
	formattedSectionStyling.wrapperColor = WRAPPER_COLOR;
	formattedSectionStyling.inverseColor = INVERSE_COLOR;
	return formatStylingObject(formattedSectionStyling);
};

const STYLE_KEY_TO_CLASS = {
	[STYLE_KEYS.TEXT_ALIGNMENT]: "lg:text",
	[STYLE_KEYS.TEXT_ALIGNMENT_MOBILE]: "text",
	[STYLE_KEYS.TITLE_SPACING]: "pb",
	// Add more mappings as needed
};

const STYLE_VALUE_TO_CLASS = {
	[STYLE_VALUES.TEXT_CENTERED]: "center",
	[STYLE_VALUES.TEXT_LEFT]: "left",
	[STYLE_VALUES.TEXT_RIGHT]: "right",
	[STYLE_VALUES.SPACING_NORMAL]: "16",
	[STYLE_VALUES.SPACING_SMALL] : '8',
	// Add more mappings as needed
};

const getClassName = (styleKey, styleValue) => {
	const baseClass = STYLE_KEY_TO_CLASS[styleKey];
	const subClass = STYLE_VALUE_TO_CLASS[styleValue];
	if (baseClass && subClass) {
		return `${baseClass}-${subClass}`;
	}
	return "";
};


export const parseClassesIntoHtml = (classes, htmlcontent, parentTagName = null) => {
	// If no classes or htmlcontent provided, return original content
	if (!classes || !htmlcontent || !Array.isArray(htmlcontent)) {
		return htmlcontent;
	}
	

	return htmlcontent.map((element) => {
	
		// Check if element is a React element with a type property
		if (element && typeof element === 'object' && element.type) {
			// Only process if type is a string (HTML tag), not a React component
			if (typeof element.type !== 'string') {
				// For React components, still process children if they exist
				if (element.props?.children) {
					return {
						...element,
						props: {
							...element.props,
							children: parseClassesIntoHtml(classes, Array.isArray(element.props.children) ? element.props.children : [element.props.children], parentTagName)
						}
					};
				}
				return element;
			}
			
			let tagName = element.type.toLowerCase();
			
			// If parent is an li and current element is a p, convert to span
			if (parentTagName === 'li' && tagName === 'p') {
				tagName = 'span';
				element = {
					...element,
					type: 'span'
				};
			}
			
			// Check if we have a class mapping for this tag type
			if (classes[tagName]) {
				// Clone the element and add/merge the className
				const existingClassName = element.props?.className || '';
				const newClassName = existingClassName 
					? `${existingClassName} ${classes[tagName]}` 
					: classes[tagName];

				return {
					...element,
					props: {
						...element.props,
						className: newClassName,
						children: element.props?.children 
							? parseClassesIntoHtml(classes, Array.isArray(element.props.children) ? element.props.children : [element.props.children], tagName)
							: element.props?.children
					}
				};
			}

			if(element.props?.children) {
				return {
					...element,
					props: {
						...element.props,
						children: parseClassesIntoHtml(classes, Array.isArray(element.props.children) ? element.props.children : [element.props.children], tagName)
					}
				};
			}
		}
		
		// Return element unchanged if no class mapping found
		return element;
	});
}